















































































































import { Component, Vue } from "vue-property-decorator";
import { User } from "../interfaces/user";
import { StudioState } from "../interfaces/studioState";
import { StudioService } from "../services/roomService";
import RegisterButton from "@/components/customActions/registerButton.vue";
import { Subscription } from "../interfaces/subscription";

@Component({ components: { RegisterButton } })
export default class Landing extends Vue {
    public studioId: string | null = null;

    public get user(): User | null {
        return this.$store.state.user;
    }

    public get isPremium(): boolean {
        if (this.$store.state.user && !this.$store.state.user.is_guest) {
            const activeSubs = this.$store.state.user.subscriptions.filter(
                (s: Subscription) => s.status == "active"
            );

            if (activeSubs.length != 0) {
                return true;
            } else return false;
        } else return false;
    }

    public get ownStudios(): StudioState[] {
        return this.user?.own_studios.map(s => s.studio) ?? [];
    }

    public get canJoin() {
        if (!this.studioId) {
            return false;
        }
        if (typeof this.studioId == "object") {
            return true;
        } else {
            return this.studioId.trim().length >= 4;
        }
    }

    public async join() {
        if (!this.studioId) {
            return;
        }

        if (this.studioId.length == 4) {
            const studioIdFromCode: {
                data: string;
                status: number;
            } = await StudioService.quickConnect(this.studioId);
            if (studioIdFromCode.status == 200) {
                this.studioId = studioIdFromCode.data;
            } else if (studioIdFromCode.status == 404) {
                this.$store.commit("showSnackbar", {
                    text: studioIdFromCode.data,
                    color: "error",
                });
                return;
            }
        }

        this.$router.push({
            name: "Studio",
            params: { studioId: this.studioId },
        });
    }

    public onStudioIdChange(value: null | string | { studioId: string }) {
        if (!value) {
            this.studioId = null;
            return;
        }
        if (typeof value == "object") {
            this.studioId = value.studioId;
            return;
        }

        this.studioId = value;
    }
}
